{"id":"LanguageSelect","prefabs":{"default":{"children":[{"component":"LanguageSelect","options":"options:*"}]}}}